module.exports = __webpack_public_path__ + "img/dh.70c4bd75.png";